// JOB-01's address (06-qol §6): the search, the filters, the scope and the page, so a link or a
// saved view shows a colleague the same list.

export interface JobListSearch {
  readonly q?: string;
  readonly status?: string;
  readonly venture?: string;
  readonly department?: string;
  /** "My jobs / All jobs" (DECISIONS-LOG 2026-10-12 Q3). Absent means the viewer's default. */
  readonly scope?: string;
  /** Only past the first page. A number, so the address reads `?page=2`. */
  readonly page?: number;
}

const TEXT_KEYS = ['q', 'status', 'venture', 'department', 'scope'] as const;

/** The route's reading of the address: text stays text, and a page is a whole number above 1. */
export function readJobListSearch(raw: Readonly<Record<string, unknown>>): JobListSearch {
  const next: { -readonly [K in keyof JobListSearch]: JobListSearch[K] } = {};
  for (const key of TEXT_KEYS) {
    const value = raw[key];
    if (typeof value === 'string' && value !== '') next[key] = value;
  }
  const page = Number(raw.page);
  if (Number.isInteger(page) && page > 1) next.page = page;
  return next;
}

/** S32 (Q28): a saved view keeps the address bar's filters as they are written there — never the page. */
export function viewFiltersOf(search: JobListSearch): Record<string, string> {
  const filters: Record<string, string> = {};
  for (const key of TEXT_KEYS) {
    const value = search[key];
    if (value !== undefined) filters[key] = value;
  }
  return filters;
}
